import React from "react";

import { AlertCircle } from "lucide-react";

import { FieldStatusIcon } from "../shared/FieldStatusIcon";
import { FieldWithAutoFill } from "../shared/FieldWithAutoFill";

interface BusinessGoalFieldProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  getFieldStatus: (value: string) => string;
  onFieldHelp?: (fieldType: string) => void;
}

export const BusinessGoalField: React.FC<BusinessGoalFieldProps> = ({
  value,
  onChange,
  error,
  getFieldStatus,
}) => {
  const placeholder =
    "Reduce credit card application completion time by 60% and increase approval-to-activation conversion rate by 25% through a simplified digital-first application experience";

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3">
        <FieldStatusIcon status={getFieldStatus(value)} />
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-base font-semibold text-white">
              Business goal <span className="text-green-500">*</span>
            </span>
          </div>
        </div>
      </div>

      <FieldWithAutoFill
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        suggestedValue={placeholder}
        type="textarea"
        rows={3}
        required
      />

      <p className="text-sm text-white/60">
        Define the specific, measurable outcome you want to achieve
      </p>

      {error && (
        <div className="flex items-center gap-2">
          <AlertCircle size={14} className="text-red-400" />
          <p className="text-sm text-red-400">{error}</p>
        </div>
      )}
    </div>
  );
};
